import React from 'react';
import Proce from './Proce';
import callApi from './../../utils/apicaler';
import {storage} from './../../utils/ConfigFirebase';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import NavMeauBar from '.././pageManager/const_childer/nav_meau';
import  { Redirect } from 'react-router-dom'
import '.././puclic/scss/style.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'
import axios from 'axios';   
import {
  Link
} from "react-router-dom";

class CreatePage extends React.Component{
    constructor(props){
            super(props);

            this.state = {
                products:"",
                price:"",
                species:"",
                kho:"",
                describe:"",
                date:Date(),
                image: null,
                valueInput:"",
                imageName:"",
                progress:"",
                loader:"",
                heyConten:"",
                showMeau:"",
                active:true,
                progress:0,
                ERRimage:"",
                ERRproducts:"",
                ERRprice:"",
                ERRspecies:"",
                ERRdescribe:"",
                imgeFile:"",
                image1:"",
                image2:"",
                image3:"",
                image4:"",
                file: '',
                file1: '',
                file2: '',
                file3: '',
                file4: '',
                imagePreviewUrl: '',
                redirct:0,
                alertCustom:"",
                color:"",
                isTrueLogin:false,
                size:""
            }

            this.onChangeProducts = this.onChangeProducts.bind(this);
            this.onChangePrice = this.onChangePrice.bind(this);
            this.onChangeSpecies = this.onChangeSpecies.bind(this);
            this.onChangeKho = this.onChangeKho.bind(this);
            this.onChangeDescribe = this.onChangeDescribe.bind(this);
            this.onChangeDate = this.onChangeDescribe.bind(this);
            this.onChangeImage = this.onChangeImage.bind(this);
            // this.onChangeImage1 = this.onChangeImage1.bind(this);
            // this.onChangeImage2 = this.onChangeImage2.bind(this);
            // this.onChangeImage3 = this.onChangeImage3.bind(this);
            // this.onChangeImage4 = this.onChangeImage4.bind(this);
            this.onChangeColor = this.onChangeColor.bind(this);
            this.onChangeConten = this.onChangeConten.bind(this);
            this.onSubmit = this.onSubmit.bind(this);
        }

        
    componentDidMount(){

        const cookie = document.cookie
         if(cookie === "0fe8cf3262d72131ec5d304cd3d8190b"){
            this.setState({isTrueLogin : true})
         }


    }

    onChangeProducts(e){
        this.setState({
            products: e.target.value
        });
    }

    onChangePrice(e){
        this.setState({
            price: e.target.value
        });
    }
    onChangeSpecies(e){
          this.setState({
            species:e.target.value
          })
    }
    onChangeKho(e){
          this.setState({
            kho:e.target.value
          })
    }

    onChangeDescribe(html){
        this.setState({
            describe: html
        });
        console.log(html)
    }
    onChangeDate(e){
        this.setState({
            date: e.target.value
        });
    }
    onChangeColor(e){
        this.setState({
            color: e.target.value
        });
    }

    onChangeImage(e){
        let file = e.target.files[0];

          this.setState({
            file: file
          }); 
    }
    onChangeConten(e){
        this.setState({
            conten: e.target.value
        });
    }

    onChangeSize=(e)=>{
        this.setState({
            size: e.target.value
        });
    }

    callApiImgur = (products, price, species, describe, file, kho, date, color, size, conten) =>{

        var param = file
        console.log(file)
        let data = new FormData();
        data.append('image', file);
        console.log(data)
        
        let config = {
            method: 'post',
            url: 'https://api.imgur.com/3/image',
            headers: { 
                'Authorization': 'Client-ID 20fa25cfc3dea77'
            },
            data : data
        };
        
        axios(config)
        .then((res) => {
            const {data} = res.data;
            var link = data.link;
            {this.callApiFunc(products, price, species, describe, file, kho, date, color, size, conten, link)}
        })   

    }


    callApiFunc = (products, price, species, describe, file, kho, date, color, size, conten, link) => {

        axios.post('https://t5f1805b29d37b001382761af.herokuapp.com/create',{
                imgeFile:link,
                products:products,
                price:price,
                species:species,
                describe:describe,
                kho:kho,
                date:date,
                color:color,
                size:size,
                conten:conten
        })
            .then((res)=> {
                this.setState({redirct : res.status})
            })
            .catch((err)=> {
                console.log(err);
            })
    } 

    onSubmit(e){
        e.preventDefault();
        var { products, price, species, describe, file, kho, date, color, size, conten} = this.state;
        
        if(!file){
          this.setState({ERRimage:"ERRimage"})
          return true;
        }
        if(!products){
          this.setState({ERRproducts:"ERRproducts"})
          return true;
        }
        if(!price){
          this.setState({ERRprice:"ERRprice"})
          return true;
        }
        if(!species){
          this.setState({ERRspecies:"ERRspecies"})
          return true;
        }
        if(!describe){
          this.setState({ERRdescribe:"ERRdescribe"})
          return true;
        }
        this.setState({alertCustom : "alertCustom"})
        // {this.thenGetDownloadUrl()}
        
        {this.callApiImgur(products, price, species, describe, file, kho, date, color, size, conten)}

        
          
    }

    showMeau = () =>{
        this.setState({
            showMeau:"showMeau",
            heyConten:"heyConten"
        })
    }
    closeMeau = () =>{
        this.setState({
            showMeau:"",
            heyConten:""
        })
    }


    render(){
        const   {
                   isTrueLogin, loader, heyConten, showMeau, imageName, progress,imgeFile,redirct,alertCustom
                    
                } = this.state
        var wapper = <div className={`container-fluid custom-fluid`}>
                        <div className="row custom_row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                                <div className="wapper" >
                                    <div className={`nav_bar ${showMeau}`}>
                                        <h3>elsoule</h3>
                                        <hr/>
                                        <div className="nav_meau">
                                                <NavMeauBar activeProduct={this.state.active} />
                                        </div>  
                                    </div>
                                    <div className={`conten ${heyConten}`}>
                                            { heyConten === "heyConten" ? <div className="meau_mobi" onClick={this.closeMeau}> <CloseIcon /> </div> : <div className="meau_mobi" onClick={this.showMeau}> <MenuIcon /> </div> }
                                        <h3>Thêm sảm phẩm</h3>
                                            <div className="row custom_row" id={alertCustom !== "" ? "alertCustom" : ""}>
                                                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 custom_col">
                                                    <div className="card">
                                                      <div className="img_bia">
                                                      </div>
                                                      <div className="card-body">
                                                        
                                                        <h5 className="card-title">Bich cho</h5>
                                                        <p className="card-text">Ngu si</p>
                                                        <hr/>
                                                        <div className="send_mail">
                                                            <button type="button" style={{padding:"2px 10px"}}>Xem Them</button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="card">
                                                    {/*  <div className="box_upload">
                                                        
                                                        <h3 className="card-title">Img Product</h3>
                                                        { imgeFile ? <img src={imgeFile} /> : ""}
                                                      </div>*/}
                                                    </div>

                                                </div>

                  
                                                <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 custom_col">
                                                    <form onSubmit={this.onSubmit} encType="multipart/form-data" action="/create" >
                            
                                                        {this.showTable()}
                                                    
                                                        <button type="submit" 
                                                                className="btn btn-primary upload_button"
                                                        >
                                                        Upload
                                                        </button>
                                                    </form>
                                                    
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        {alertCustom !== "" ? <div className=""><Proce /></div> : ""}         
                        {redirct === 200 ? <Redirect to='manager'  /> : ""}
                    </div>
        var notFaul = <div style={{color:"red", fontSize:"20px", textAlign:"center"}}>Dừng lại! </div> 
        return(
            <div>{isTrueLogin === true ? wapper : notFaul}</div>            
                        
            )
    }
    showTable = () =>{
        const tables =[
            {
                input: <div><p>Date</p><input type="text" name="date" className="form-control date" disabled placeholder={Date()} value={Date()} onChange={this.onChangeDate}/></div>
            },
            {
                input: <div className="" >
                          <select style={{width:"20%", height:"50px", background:"#cce5ff96", border:"none"}} defaultValue={'DEFAULT'} className="form-control input-custom" id="inlineFormCustomSelect" onChange={this.onChangeConten} name="conten">
                            <option value="DEFAULT" disabled>Chọn mục</option>
                            <option defaultValue="1">Mỹ phẩm</option>
                            <option defaultValue="1" style={{color:"red"}}>HÀNG SALE</option>
                            <option defaultValue="3">Lặt vặt</option>
                            <option defaultValue="3">Thời trang</option>
                            <option defaultValue="3">Phụ kiện tiện ích</option>
                            <option defaultValue="3">Trang trí nội thất</option>
                            <option defaultValue="3">Giai Trí</option>
                            <option defaultValue="3">Điện thoại</option>
                            <option defaultValue="3">Văn phòng phẩm</option>

                          </select>
                        </div>
            },
            {
                input:<div><p>Tên sản phẩm</p><input type="text" name="products" className={`form-control ${this.state.ERRproducts}`} placeholder="products" onChange={this.onChangeProducts}/></div>
            },
            {
                input:<div><p>Thể loại</p><input type="text" name="species" className={`form-control species ${this.state.ERRspecies}`} placeholder="Thể loại" onChange={this.onChangeSpecies}/></div>
            },
            {
                input:<div><p>Kho</p><input type="text" name="kho" className={`form-control species`} placeholder="kho" onChange={this.onChangeKho}/></div>
            },
            // {
            //     input:<div>
            //             <p>Màu sản phẩm</p>
            //             <input className="form-check-input" type="text" name="color" id="inlineRadio1" onChange={this.onChangeColor}/>
            //         </div>
            // },
            //  {
            //     input:<div>
            //             <p>Size</p>
            //             <input className="form-check-input" type="text" name="size" id="inlineRadio1" onChange={this.onChangeSize}/>
            //         </div>
            // },
            {
                input:<div><p>Gía</p><input type="number" name="price" className={`form-control price ${this.state.ERRprice}`} placeholder="$" onChange={this.onChangePrice}/><b>.000 Vnd</b></div>
            },
            
            {
                input:<div><p>Hình ảnh</p><input name="imgeFile" className={`form-control file imageFile ${this.state.ERRimage}`} id="exampleFormControlFile1" type="file" onChange={this.onChangeImage} /></div>
            },
            {
                input:<div>
                        <p>Mô tả sản phẩm</p>
                        <ReactQuill 
                          theme={this.state.theme}
                          onChange={this.onChangeDescribe}
                          modules={CreatePage.modules}
                          formats={CreatePage.formats}
                          bounds={'.app'}
                         />
                     </div>
            }
        ]
        var result = null;
            result = tables.map((table, index)=>{
                return (
                    <div className="form-group" key={index}>
                        <label></label>
                        {table.input}
                    </div>
                )
            })
        

        return result;
    }

}


CreatePage.modules = {
  toolbar: [
    [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
    [{size: []}],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{'list': 'ordered'}, {'list': 'bullet'}, 
     {'indent': '-1'}, {'indent': '+1'}],
    ['link', 'image', 'video'],
    ['clean']
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  }
}
/* 
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
CreatePage.formats = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent',
  'link', 'image', 'video'
]

/* 
 * PropType validation
 */
export default CreatePage;